// @flow

import React from 'react'
import { compose } from 'recompose'
import { Trans, withI18n } from '@lingui/react'

import withStyles from 'material-ui/styles/withStyles'
import Grid from 'material-ui/Grid'
import Typ from 'material-ui/Typography'

import Section from 'components/Section'

type Props = {
  classes: Object,
  i18n: Object,
}

const PristopSection = ({ classes, i18n }: Props) => (
  <Section className={classes.root} anchor={i18n._('pristop.slug')}>
    <Typ className={classes.title} variant={'headline'}>
      <Trans id='pristop.title' />
    </Typ>
    <Typ className={classes.lead} variant={'subheading'}>
      <Trans id='pristop.lead' />
    </Typ>
    <div className={classes.image} />
    <Grid className={classes.grid} container>
      <Grid item xs={12} sm={12} md={4}>
        <Typ className={classes.listTitle} variant={'body2'}>
          <Trans id='pristop.list1_title' />
        </Typ>
        <Typ className={classes.list} component={'ul'}>
          <Typ component={'li'}>
            <Trans id='pristop.list1_item1' />
          </Typ>
          <Typ component={'li'}>
            <Trans id='pristop.list1_item2' />
          </Typ>
          <Typ component={'li'}>
            <Trans id='pristop.list1_item3' />
          </Typ>
          <Typ component={'li'}>
            <Trans id='pristop.list1_item4' />
          </Typ>
        </Typ>
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <Typ className={classes.listTitle} variant={'body2'}>
          <Trans id='pristop.list2_title' />
        </Typ>
        <Typ className={classes.list} component={'ul'}>
          <Typ component={'li'}>
            <Trans id='pristop.list2_item1' />
          </Typ>
          <Typ component={'li'}>
            <Trans id='pristop.list2_item2' />
          </Typ>
          <Typ component={'li'}>
            <Trans id='pristop.list2_item3' />
          </Typ>
          <Typ component={'li'}>
            <Trans id='pristop.list2_item4' />
          </Typ>
        </Typ>
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <Typ className={classes.listTitle} variant={'body2'}>
          <Trans id='pristop.list3_title' />
        </Typ>
        <Typ className={classes.list} component={'ul'}>
          <Typ component={'li'}>
            <Trans id='pristop.list3_item1' />
          </Typ>
          <Typ component={'li'}>
            <Trans id='pristop.list3_item2' />
          </Typ>
          <Typ component={'li'}>
            <Trans id='pristop.list3_item3' />
          </Typ>
          <Typ component={'li'}>
            <Trans id='pristop.list3_item4' />
          </Typ>
        </Typ>
      </Grid>
    </Grid>
  </Section>
)

const styles = theme => ({
  root: {
    //
  },
  title: {
    marginBottom: theme.spacing.unit * 4,
  },
  lead: {
    marginBottom: theme.spacing.unit * 2,
  },
  image: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      width: `calc(100% + ${theme.spacing.unit * 6}px)`,
      position: 'relative',
      paddingBottom: '22%',
      backgroundImage: `url(${require('./images/net.svg')})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center ',
      backgroundSize: '120%',
    },
  },
  content: {
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  grid: {
    maxWidth: '1640px',
    margin: '0 auto',
  },
  listTitle: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing.unit * 4,
    letterSpacing: '0.5px',
    fontFamily: 'Gotham, sans-serif',
    fontWeight: '700',
    textTransform: 'uppercase',
    '&:after': {
      display: 'inline-block',
      content: '""',
      width: '35px',
      height: '5px',
      background: '#0071bc',
      margin: `${theme.spacing.unit * 2}px 0`,
    },
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
    },
  },
  list: {
    listStyle: 'none',
    fontWeight: '300',
    margin: '0',
    padding: '0',
    color: theme.typography.body1.color,
    '& li': {
      marginBottom: theme.spacing.unit / 2,
    },
  },
})

export default compose(
  withI18n(),
  withStyles(styles)
)(PristopSection)



// WEBPACK FOOTER //
// ./src/components/Pristop/index.js